export default __webpack_public_path__ + "static/media/logo.57fc662d.svg";